<template>
    <v-layout column fill-height>
        <v-layout class="main">

            <v-overlay :value="fullLoading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-layout row class="content-header">
                <v-flex md3>
                    <form :action="`${urlPostSalesForce}`" method="POST">
                        <v-text-field label="SAMLResponse" name="SAMLResponse" id="SAMLResponse" v-model="samlResponseAvisoSinistro" outlined ></v-text-field>
                        <v-btn color="info" type="submit" id="btnLoginAvisoSinistroSF"><v-icon>check</v-icon>&nbsp; SSO Login - Aviso Sinistro</v-btn>      
                    </form>      
                </v-flex>
            </v-layout>   

        </v-layout>

    </v-layout>
</template>

<script>

import Vue from 'vue';
import { mapGetters } from "vuex";

export default {

    data() {
        return {
            subject: "",
            samlResponseAvisoSinistro: "",
            fullLoading: true,
            urlPostSalesForce: process.env.VUE_APP_SSO_SALES_FORCE
        }
    },  

    computed: {
        ...mapGetters("usuarioModule", { usuario: "getUsuario" })
    },

    methods: {

        async enviarRequisicao() {

            let request = {
                subject: this.subject,
                tipoPortal: 1
            };

            let paramsRequestContaContato = {
                tipoPortal: 1, //Aviso Sinistro ou Portal Corretor
                userId: this.usuario.userId,
                personId: parseInt(this.usuario.personId)
            };

            try {

                const config = {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
                const resultCriacaoContaContato = await Vue.prototype.$httpIdentityServerApi.post("person/createUserContactSF", paramsRequestContaContato, config);

                console.log('resultCriacaoContaContato', resultCriacaoContaContato);

                if (resultCriacaoContaContato.status === 200) {

                    const resultAvisoSinistro = await Vue.prototype.$httpPortal.post("SAML/getSAMLResponse", request);

                    console.log('resultAvisoSinistro', resultAvisoSinistro);
                
                    this.samlResponseAvisoSinistro = resultAvisoSinistro.data.ObjetoRetorno;

                    // document.getElementById('btnLoginAvisoSinistroSF').click();
                }
            }
            catch(ex){
                console.log(ex);
            }
        }
    },

    async created() {
        let cnpjCorretor = localStorage.getItem("cpfCnpj");
        let userCpf = localStorage.getItem("userCpf");
        this.subject = cnpjCorretor + "_" + userCpf;
        this.fullLoading = true;
        await this.enviarRequisicao();
        this.fullLoading = false;
    }
};

</script>